import { ReactNode, useEffect, useState } from "react";
import { LoadingIndicator } from "components";
import { initI18n, fallbackLanguage } from "../i18n";

interface DetectedLanguageProviderProps {
  children: ReactNode;
}

// used when we can't get language from API, then we use fallback language
export const InitialLanguageProvider = ({
  children,
}: DetectedLanguageProviderProps) => {
  console.log("[InitialLanguageProvider] mounting");
  const [isReady, setIsReady] = useState(false);

  useEffect(() => {
    console.log("[InitialLanguageProvider] initializing i18n...");
    // we can't get language from API, so we use fallback language
    initI18n(fallbackLanguage, () => {
      console.log("[InitialLanguageProvider] i18n initialized, setting isReady");
      setIsReady(true);
    });
  }, []);

  if (!isReady) {
    console.log("[InitialLanguageProvider] not ready");
    return (
      <div className="h-screen">
        <LoadingIndicator center />
      </div>
    );
  }
  console.log("[InitialLanguageProvider] rendering children");
  return <>{children}</>;
};
